import { createSelector } from '@reduxjs/toolkit';
import { selectLocationType, selectSearchResultFacetsTrackingCommonProperties } from 'features/searchResultsFacets';
import { selectSearchMapTrackingCommonProperties } from 'features/searchResultsMap';
import { selectUserLocation, selectUserProfileTrackingCommonProperties } from 'features/userProfile';
import { selectUtmTrackingCommonProperties } from 'features/utm';

/**  This code is defining a selector which its main purpuse is to combine in a single object
 * a set of properties from different features.
 * The selector takes two other selector as arguments.
 * these selctores provide a set of properties from different features
 * this selector is inteded to be consumed by different events builders such as segment ot g4.
 */
const selectTrackingCommonProperties = createSelector(
  selectSearchResultFacetsTrackingCommonProperties,
  selectUserProfileTrackingCommonProperties,
  selectUserLocation,
  selectUtmTrackingCommonProperties,
  selectSearchMapTrackingCommonProperties,
  selectLocationType,
  (facets, userProfile, userLocation, utm, map, locationType) => ({
    marketId: facets.location?.marketId,
    marketName: facets.location?.marketName,
    city: facets.location?.city,
    stateAbbreviation: facets.location?.marketState,
    stateName: facets.location?.marketStateName,
    zip: facets.location?.zip,
    brandId: facets.brandId,
    brandName: facets.brandName,
    userId: userProfile.userId,
    name: userProfile.name,
    email: userProfile.email,
    phone: userProfile.phone,
    userZip: userProfile.zip,
    livesOutside: userProfile.livesOutside,
    favorites: userProfile.favorites,
    neustarSegment: userProfile.neustarSegment,
    neustarZip: userProfile.neustarZip,
    neustarAge: userProfile.neustarAge,
    neustarGender: userProfile.neustarGender,
    facets: facets.facetsList,
    price: facets?.price,
    schools: facets.schools,
    listingCount: facets.listingCount,
    pageNumber: facets.pageNumber,
    moveInDate: facets.moveInDate,
    searchLocation: facets.location,
    userLocationCity: userLocation.userLocationCity,
    userLocationCountry: userLocation.userLocationCountry,
    userLocationMarketId: userLocation.userLocationMarketId,
    userLocationState: userLocation.userLocationState,
    userLocationZipCode: userLocation.userLocationZipCode,
    isLoggedIn: userProfile.isLoggedIn,
    referCode: utm.refer,
    isSearchWithinMap: map.isSearchWithinMap,
    locationType,
  })
);

export default selectTrackingCommonProperties;
